import styled from 'styled-components';

export const LoadingState = styled.div`
    display: grid;
    align-content: start;
    justify-items: center;
    box-sizing: border-box;
    gap: var(--space-4, 16px);
    width: 100%;
    padding: clamp(16px, 3vw, 24px);
`;

export const LoadingPreview = styled.div`
    width: 100%;
    padding: var(--space-4, 16px);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-lg, 12px);
    background: var(--color-background);
`;
